import { graphql } from 'gatsby';

import indexPageWrapper from '../components/IndexPage';

const indexPage = indexPageWrapper('geospatial-information');

export default indexPage;

/* eslint-disable no-undef */
export const pageQuery = graphql`
  query GeoQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(filter: {frontmatter: {path: {regex: "/^\/geospatial-information/i" }}}) {
      edges {
        node {
          id
          html
          frontmatter {
            path
            title
            menuOrder
          }
        }
      }
    }
  }
`;
